import { useMemo } from 'react';
import { StringParam, withDefault } from 'use-query-params';
import { usePageParams } from '../../../hooks/usePageParams';

export type ReportsLandingPageParams = {
  customerID: string; // Note: using customerID (not customerId) for consistency with context-aware navigation
};

export function useReportsLandingPageParams() {
  const config = useMemo(
    () => ({
      customerID: withDefault(StringParam, ''),
    }),
    []
  );

  return usePageParams<ReportsLandingPageParams>(config);
}
